import { useState } from 'react';

import { ActionIcon } from 'ui';
import { IconHambMenu } from 'ui/Icons';

import { MobileMenuDrawer } from './MobileMenuDrawer';

const MobileHamburgerMenu = () => {
  const [isMenuDrawerOpen, setIsMenuDrawerOpen] = useState(false);
  return (
    <>
      <ActionIcon size="md" variant="gray" onClick={() => setIsMenuDrawerOpen(true)}>
        <IconHambMenu />
      </ActionIcon>
      <MobileMenuDrawer opened={isMenuDrawerOpen} onClose={() => setIsMenuDrawerOpen(false)} />
    </>
  );
};

export { MobileHamburgerMenu };
